export const ADD_NEW_BRANDS = "ADD_NEW_BRANDS";
export const DELETE_BRANDS = "DELETE_BRANDS";
export const GET_BRANDS = "GET_BRANDS";


// WEBPACK FOOTER //
// ./src/components/brands/actions/types.js